import React, { useEffect, useState, Fragment, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import DashboardLayout from "../../molecules/DashboardLayout";

import { Row, Col, Pagination, Card, Button } from "antd";

import DragAndDropList from "../../atoms/Grid/gridColumnSort";
import { SectionHeaderV2 } from "../../organism/SectionHeaderV2";
import Grid from "../../atoms/Grid";
import { getLeaseForms, visiblePopup } from "./ducks/actions";
import { Popup } from "../../atoms/Popup";

import { useSearchHistory } from "../../../utils/filterHelper";
import { setFilterLease } from "../App/SearchFilters/ducks/actions";
import LoaderTsx from "../Loader.tsx";
import SideDrawer from "../../molecules/SideDrawer";
import { leaseCol, leaseColumn } from "./leaseColumn";
import { getGridSettings } from "../../../utils/globalService";
import AdditionalFilters from "./AdditionalFilters";
import { searchByOptions as baseSearchByOptions } from "./constants/searchByOptions";
import { useFeatureToggleSearchByOptions } from "../../../hooks/search";
import { useLeasesSearch } from "./hooks";
import { getOrgByID } from "../../modules/Maintenance/Tickets/ducks/actions";
import { usagesTypeFilters } from "../../../utils/helper";
import { InfoCircleOutlined } from "@ant-design/icons";
import BookingLeaseRequests from "../BookingListing/bookingLeaseRequests/bookingLeaseRequests";
import Title from "antd/es/typography/Title";
import { useGetLeaseAmendmentPendingRequest } from "./hooks/useGetleaseAmendmentPendingRequest";
import { useGetOrganization } from "../../../api/v1";
import { resetGridSettings } from "../../libs/constants";
import { useGridReset } from "../../../hooks/useGridReset";

const gridProps = {
  sortable: true,
  filter: true,
  resizable: true,
  minWidth: 220,
};

const limit = 50;

const bookingStatuses = [
  {
    label: "All",
    value: "all",
  },
  {
    label: "Active",
    value: "active",
  },
  {
    label: "Active Renewing",
    value: "active_renewing",
  },
  {
    label: "Active Vacating",
    value: "active_vacating",
  },
  {
    label: "Lease Expired",
    value: "lease_expired",
  },
  {
    label: "Lease Terminated",
    value: "lease_terminated",
  },
  {
    label: "Lease Renewed",
    value: "lease_renewed",
  },
];

const LeaseformList = (props) => {
  const dispatch: any = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [bookingStatus, setBookingStatusFilter] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const filter = useSelector((state: any) => state.filters.leasesData);
  const [selectedSearchBy, setSelectedSearchBy] = useState(Object.keys(filter)[0] ?? "unitCode");
  const [searchValue, setSearchValue] = useState(filter[Object.keys(filter)[0]] ?? "");
  const [dateFrom, setDateFrom] = useState(null);
  const [startDateFrom, setStartDateFrom] = useState(null);
  const [startDateTo, setStartDateTo] = useState(null);
  const [vactingDateFrom, setVactingDateFrom] = useState(null);
  const [vactingDateTo, setVactingDateTo] = useState(null);
  const [endDateFrom, setEndDateFrom] = useState(null);
  const [endDateTo, setEndDateTo] = useState(null);
  const { searchHistory, addToSearchHistory } = useSearchHistory(setFilterLease);
  const [exportData, setExportData] = useState(false);
  const leaseformdata = useSelector((state: any) => state.leases.getLeaseForms);
  const [leaseColumns, setLeaseColumns] = useState(() => [...leaseCol]);
  const [detectColumnChanges, setDetectColumnChanges] = useState(false);
  const [screenSize, setScreenSize] = React?.useState("");
  const [drawer, setDrawer] = useState(false);
  const [currenLease, setCurrentLease] = useState(true);
  const [triger, setTriger] = useState(0);
  const [visible, setVisible] = useState(false);

  const [usagesTypeInitial, setUsageTypeInitial]: any = useState({ value: "all" });
  const { organization: organizationDetail } = useGetOrganization();

  const { data: pendingRequest, loading, error, refetch } = useGetLeaseAmendmentPendingRequest<any>("pending");

  const organization = useSelector((state: any) => state.tickets.orgData);

  const { selectOptions, handleSearch, handleChangeSearchBy } = useLeasesSearch({
    selectedSearchBy,
    setSelectedSearchBy,
    setSearchValue,
  });

  const popup = [
    {
      title: (
        <Title level={3} className=" mb-0">
          Booking/Lease Request(s)
        </Title>
      ),
      content: (
        <BookingLeaseRequests
          getAllBookRequests={pendingRequest}
          getAllLeaseRequests={{ data: [] }}
          getAllPlanRequests={{ data: [] }}
        />
      ),
      width: 1650,
    },
  ];

  const popupProps = {
    closable: true,
    visibility: visible,
    title: popup[triger].title,
    content: popup[triger].content,
    width: popup[triger].width,
  };
  useLayoutEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      if (width >= 1500) {
        setScreenSize("xl");
      } else if (width >= 992) {
        setScreenSize("lg");
      } else {
        setScreenSize("smaller than lg");
      }
    };

    // Initial check
    checkScreenSize();
    // Add event listener to update on resize
    window.addEventListener("resize", checkScreenSize);
    // Clean up the event listener on unmount
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const handlePagination = (pg) => {
    setCurrentPage(pg);
    setIsLoading(true);
    let usagesType = usagesTypeInitial?.value === "all" ? "" : usagesTypeInitial?.value;
    dispatch(
      getLeaseForms(
        limit,
        pg,
        searchValue,
        selectedSearchBy,
        setIsLoading,
        bookingStatus?.value,
        exportData,
        setExportData,
        leaseformdata?.totalCount,
        startDateFrom,
        startDateTo,
        vactingDateFrom,
        vactingDateTo,
        endDateFrom,
        endDateTo,
        currenLease,
        leaseColumns,
        usagesType
      )
    );
  };
  const { resetGrid, setGridReset } = useGridReset();
  useEffect(() => {
    const buildLeaseColumnsWithKyc = (org) => {
      const kycFields = [...(org?.commercialKycForm || []), ...(org?.residentialKycForm || [])].filter(
        (field, index, self) => index === self.findIndex((f) => f.name === field.name)
      );

      const dynamicKycCols = kycFields.map((field, index) => ({
        id: 46 + index,
        headerName: field.label,
        field: `kycDetails.${field.name}`,
        checked: false,
        hide: true,
      }));

      const mergedLeaseCols = [...leaseCol, ...dynamicKycCols];
      getGridConfig(mergedLeaseCols);
      setLeaseColumns(mergedLeaseCols);
    };

    const init = async () => {
      const isOrgEmpty = !organization || (typeof organization === "object" && Object.keys(organization).length === 0);

      if (isOrgEmpty) {
        const orgData = localStorage?.getItem("login-response");
        const orgId = orgData ? JSON.parse(orgData) : null;
        if (orgId) {
          await dispatch(getOrgByID(orgId?.orgId));
        }
      } else {
        buildLeaseColumnsWithKyc(organization);
      }
    };

    init();
  }, [organization, resetGrid]);

  const getGridConfig = async (columns) => {
    let result = await getGridSettings("lease", columns, resetGrid);
    if (result?.length) {
      setLeaseColumns(result);
      setGridReset(false);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
    addToSearchHistory(selectedSearchBy, searchValue);
    setIsLoading(true);
    let usagesType = usagesTypeInitial?.value === "all" ? "" : usagesTypeInitial?.value;
    dispatch(
      getLeaseForms(
        limit,
        1,
        searchValue,
        selectedSearchBy,
        setIsLoading,
        bookingStatus?.value,
        exportData,
        setExportData,
        leaseformdata?.totalCount,
        startDateFrom,
        startDateTo,
        vactingDateFrom,
        vactingDateTo,
        endDateFrom,
        endDateTo,
        currenLease,
        leaseColumns,
        usagesType
      )
    );
  }, [
    searchValue,
    bookingStatus?.value,
    exportData,
    startDateFrom,
    startDateTo,
    vactingDateFrom,
    vactingDateTo,
    endDateFrom,
    endDateTo,
    currenLease,
    usagesTypeInitial?.value,
  ]);

  const { searchByOptions } = useFeatureToggleSearchByOptions(baseSearchByOptions);

  useEffect(() => {
    let key = Object.keys(searchHistory)[0];
    if (searchByOptions.length > 0)
      searchByOptions.map((item) => {
        if (key == item.value) item["default"] = true;
        else item["default"] = false;
        return item;
      });
  }, [searchHistory]);

  const exportAction = () => {
    setExportData(true);
  };

  const filterReset = () => {
    setStartDateFrom(null);
    setStartDateTo(null);
    setVactingDateFrom(null);
    setVactingDateTo(null);
    setEndDateFrom(null);
    setEndDateTo(null);
    setBookingStatusFilter({ value: "all" }), setSelectedSearchBy(null);
    setSearchValue(null);
  };

  const handelFilters = (value) => {
    if (value?.title === "usagesType") {
      setUsageTypeInitial(value);
    }
  };

  return (
    <Fragment>
      <DashboardLayout>
        <Row gutter={[32, 32]}>
          <Col span={24}>
            <Row gutter={[24, 24]}>
              <Col span={24}>
                <SectionHeaderV2
                  heading="Leases"
                  downloadAction={exportAction}
                  bookingStatusFilter={setBookingStatusFilter}
                  headTopLeftText={
                    organizationDetail?.enableLeaseAmendment &&
                    pendingRequest?.data?.length > 0 && (
                      <Button danger type="text" onClick={() => setVisible(true)}>
                        {pendingRequest?.data?.length} <InfoCircleOutlined /> pending requests
                      </Button>
                    )
                  }
                  //@ts-ignore
                  cancelledBookingCheck={false}
                  bookingStatus={true}
                  bookingStatuses={bookingStatuses}
                  viewOption={usagesTypeFilters(usagesTypeInitial?.value)}
                  bookingStatusTitle={"Status"}
                  total={leaseformdata?.totalCount || 0}
                  onSearch={handleSearch}
                  onChangeSearchBy={handleChangeSearchBy}
                  defaultSearch={searchValue}
                  handleView={handelFilters}
                  searchByOptions={searchByOptions}
                  selectOptions={selectOptions}
                  setCheckBoxValue={setCurrentLease}
                  checkBoxValue={currenLease}
                  currentScreen={"lease"}
                  setDateFrom={setDateFrom}
                  dateFrom={dateFrom}
                  leaseScrrenDateFilters={true}
                  justifyEnd={true}
                  setDrawer={setDrawer}
                  additionalFilters={true}
                  filterStyle={{ marginRight: "10px" }}
                />
              </Col>
              <Col span={23}>
                <Pagination
                  className="ag-property-text-pagination"
                  total={leaseformdata?.totalCount || 0}
                  showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total} Leases`}
                  showSizeChanger={false}
                  defaultPageSize={50}
                  defaultCurrent={1}
                  current={currentPage}
                  onChange={(e) => handlePagination(e)}
                />
              </Col>
              <Col span={1}>
                <div style={{ display: "flex", justifyContent: "end" }}>
                  <DragAndDropList
                    columns={leaseColumns}
                    setModifiedColumns={setLeaseColumns}
                    changePicker={setDetectColumnChanges}
                    detectColumnChanges={detectColumnChanges}
                    screenName="lease"
                    setGridReset={setGridReset}
                  />
                </div>
              </Col>
              <Col span={24}>
                <Row gutter={[24, 24]} justify="end">
                  <Col span={24}>
                    <Card bordered={false} className="ag-nospace-body">
                      {isLoading ? (
                        <LoaderTsx />
                      ) : (
                        <Grid
                          refCol="status"
                          //@ts-ignore
                          data={leaseformdata?.data ?? []}
                          columns={leaseColumn(leaseColumns)}
                          pagination={false}
                          defaultSettings={gridProps}
                          noRowlabel="Lease"
                          fullPage={true}
                        />
                      )}
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <SideDrawer
          openDrawer={drawer}
          closeDrawer={setDrawer}
          width={screenSize === "xl" ? "410px" : "370px"}
          title={"More Search Options"}
          mask={false}
          placement="right"
        >
          <AdditionalFilters
            startDateFrom={startDateFrom}
            setStartDateFrom={setStartDateFrom}
            startDateTo={startDateTo}
            setStartDateTo={setStartDateTo}
            setVactingDateFrom={setVactingDateFrom}
            vactingDateFrom={vactingDateFrom}
            vactingDateTo={vactingDateTo}
            setVactingDateTo={setVactingDateTo}
            endDateFrom={endDateFrom}
            setEndDateFrom={setEndDateFrom}
            setEndDateTo={setEndDateTo}
            endDateTo={endDateTo}
            filterReset={filterReset}
          />
        </SideDrawer>
      </DashboardLayout>
      <Popup destroyOnClose={true} onCancel={() => setVisible(false)} {...popupProps} />
    </Fragment>
  );
};

export default LeaseformList;
